export function formatDate(dateStr) {
  if (!dateStr) return "";
  const [yyyy, mm, dd] = dateStr.split("-");
  if (yyyy && mm && dd) return `${dd}/${mm}/${yyyy}`;
  return dateStr;
}

export function formatMonth(monthString) {
  if (!monthString) return '';
  const [year, month] = monthString.split('-');
  const date = new Date(year, parseInt(month, 10) - 1, 1);
  let formatted = date.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}